import React from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmModal } from "../ConfirmModal";

type Props = {
  closeModal: () => void;
  isOpened: boolean;
};

// The app's one confirmation dialog: on a phone its two buttons share the
// row inside the screen (the old 452px box with two 190px buttons ran past it).
export const LogoutModal = ({ closeModal, isOpened }: Props) => {
  const navigate = useNavigate();

  return (
    <ConfirmModal
      isOpened={isOpened}
      title={
        <>
          Do you really want to <br /> log out?
        </>
      }
      confirmText="Log out"
      confirmVariant="primary"
      onConfirm={() => navigate("/logout")}
      onCancel={closeModal}
    >
      You will be able to log in using your account
    </ConfirmModal>
  );
};
